/* eslint-disable react-hooks/rules-of-hooks */
import { useAtomValue } from 'jotai'
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { Colors, Shapes, Typographies } from 'src/components/theme'
import { Telescope } from '@emotion-icons/ionicons-sharp/Telescope'

import * as coreAtoms from 'src/v2/state/core'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${Shapes.spacing[6]}px;
  height: 345px;
  background-color: ${Colors.border};
  border-radius: ${Shapes.borderRadius}px;
`
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${Shapes.spacing[4]}px;
  a {
    font-family: ${Typographies.title2.fontFamily};
    color: ${Colors.textDark};
    margin-inline: ${Shapes.spacing[1]}px;
    text-decoration: underline;
    &:link {
      color: ${Colors.textDark};
    }
  }
`
// const ButtonWrapper = styled.div`
//   margin-top: ${Shapes.spacing[4]}px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: ${Shapes.spacing[4]}px;
// `

type UnavailableMobilityProps = {
  message?: string
}
export const UnavailableMobility = (props: UnavailableMobilityProps) => {
  const { message } = props
  const selectedEntity = useAtomValue(coreAtoms.selectedEntity)

  // const ttaFallbackLink = useMemo(() => {
  //   if (!selectedEntity) {
  //     return null
  //   }
  //   switch (selectedEntity.type) {
  //     case 'SELECTED_LOCATION':
  //     case 'SELECTED_SHOPPING_CENTER':
  //       const { hasMobility } = selectedEntity.data['am-loc']
  //       return hasMobility
  //         ? `/insights/true-trade-area?id.am-loc=${selectedEntity.data['am-loc'].id}`
  //         : `/insights/custom-polygon-tta?id.am-loc=${selectedEntity.data['am-loc'].id}`
  //     case 'SELECTED_ADDRESS':
  //       return `/insights/custom-polygon-tta?id.google=${selectedEntity.data.place_id}`
  //     default:
  //       return null
  //   }
  // }, [selectedEntity])

  // const visitsFallbackLink = useMemo(() => {
  //   if (!selectedEntity) {
  //     return null
  //   }
  //   switch (selectedEntity.type) {
  //     case 'SELECTED_LOCATION':
  //     case 'SELECTED_SHOPPING_CENTER':
  //       const { hasMobility } = selectedEntity.data['am-loc']
  //       return hasMobility
  //         ? `/insights/location-visits?id.am-loc=${selectedEntity.data['am-loc'].id}`
  //         : `/insights/custom-polygon-visits?id.am-loc=${selectedEntity.data['am-loc'].id}`
  //     case 'SELECTED_ADDRESS':
  //       return `/insights/custom-polygon-visits?id.google=${selectedEntity.data.place_id}`
  //     default:
  //       return null
  //   }
  // }, [selectedEntity])

  // if (!selectedEntity || !ttaFallbackLink || !visitsFallbackLink) {
  //   return null
  // }
  if (!selectedEntity) {
    return null
  }

  return (
    <Wrapper>
      <Telescope size={40} color={Colors.textLight} />
      <TextWrapper>
        <Typography variant="title2" color={Colors.textDark}>
          {message || "We don't have rank data for this location"}
        </Typography>
        {/* TODO: temporarily hide until we solve the negototiations with unacast */}
        {/* <Typography variant="title2m" color={Colors.textMedium}>
          You can view
          <Link href={ttaFallbackLink} color={Colors.purpleDark}>
            True Trade Area
          </Link>
          and
          <Link href={visitsFallbackLink} color={Colors.purpleDark}>
            Location Visits
          </Link>
          {selectedEntity.type !== 'SELECTED_ADDRESS' ? `by creating a geofence` : null}.
        </Typography> */}
      </TextWrapper>
      {/* <ButtonWrapper>
        <LinkSolid href={ttaFallbackLink} color={Colors.purpleDark}>
          True Trade Area
        </LinkSolid>
        <LinkSolid href={visitsFallbackLink} color={Colors.purpleDark}>
          Location Visits
        </LinkSolid>
      </ButtonWrapper> */}
    </Wrapper>
  )
}
